import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Inicio', href: '/' },
    { name: 'Empresa', href: '/empresa' },
    { name: 'Servicios', href: '/servicios' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Contacto', href: '/contacto' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: '"Pacifico", serif' }}>
              VaciadoPro
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-gray-700 hover:text-green-600 font-medium transition-colors ${
                  isActive(item.href) ? 'text-green-600 border-b-2 border-green-600' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              href="tel:+34690220944" 
              variant="primary"
              className="flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              ¡Llámanos!
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-green-600 hover:bg-gray-100"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-gray-700 hover:text-green-600 font-medium transition-colors px-2 py-1 ${
                    isActive(item.href) ? 'text-green-600' : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-2">
                <Button 
                  href="tel:+34690220944" 
                  variant="primary"
                  className="w-full flex items-center justify-center gap-2"
                >
                  <i className="ri-phone-line"></i>
                  ¡Llámanos!
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
